const ContactPage = () => {
  const locations = [
    {
      name: 'Brissbella VIP Unisex Salon',
      address: 'No 303/1 William Gopallawa Mawatha, Kandy 20000',
      phone: '+94 74 363 3914',
      whatsapp: '+94 74 363 3914',
      coordinates: {
        lat: 7.2826594,
        lng: 80.6244567,
      },
      placeId: '0x3ae3694ae39c9163:0xc8b98714351b72a',
      hours: {
        monday: 'Closed',
        tuesday: '8:00 AM - 6:00 PM',
        wednesday: '8:00 AM - 6:00 PM',
        thursday: '8:00 AM - 6:00 PM',
        friday: '8:00 AM - 6:00 PM',
        saturday: '8:00 AM - 6:00 PM',
        sunday: '8:00 AM - 6:00 PM',
      },
      hoursDisplay: 'Open 8 AM - 6 PM (Closed on Mondays)',
    },
    {
      name: 'Brissbella Academy Kandy',
      address: 'No. 360, 7/C Kandy - Colombo Rd, Kandy 20400',
      phone: '+94 77 662 0717',
      whatsapp: '+94 77 662 0717',
      coordinates: {
        lat: 7.2650246,
        lng: 80.5893544,
      },
      placeId: '0x3ae36772ce2560bf:0xbf7bed53f7f006e',
      hoursDisplay: 'Open 9 AM - 5 PM (Except Public Holidays)',
    },
    {
      name: 'Brissbella Academy Colombo',
      address: 'Kattiya Junction, Old Kesbewa Rd, Nugegoda 10250',
      phone: '+94 77 743 7130',
      whatsapp: '+94 77 743 7130',
      coordinates: {
        lat: 6.8691876,
        lng: 79.8981727,
      },
      placeId: '0x3ae3696c6faf8ec3:0x5bd44e49377996b0',
      hoursDisplay: 'Open 9 AM - 5 PM (Except Public Holidays)',
    },
  ];

  const socialMedia = {
    facebook: [
      {
        name: 'Brissbella Academy',
        url: 'https://www.facebook.com/brissbellaacademy',
      },
      {
        name: 'Brissbella VIP Salon',
        url: 'https://www.facebook.com/vipsalonkandy',
      },
      {
        name: 'Brissbella Online Store',
        url: 'https://www.facebook.com/brissbellaonlinestore',
      },
    ],
    instagram: [
      {
        name: 'Brissbella Academy',
        url: 'https://www.instagram.com/brissbella.academy/',
      },
      {
        name: 'Brissbella Wellness Store',
        url: 'https://www.instagram.com/brissbella.wellness.store/',
      },
    ],
    youtube: {
      name: 'Brissbella Academy',
      url: 'https://www.youtube.com/channel/UC8RDbIoUP75tDj5Xt25Azcg',
    },
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-primary-600 to-primary-800">
              Contact Us
            </h1>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Get in touch with us through any of our locations or social media
              channels. We're here to help you with all your beauty and wellness
              needs.
            </p>
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Our Locations
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {locations.map((location) => (
              <div
                key={location.placeId}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
              >
                {/* Map */}
                <div className="aspect-video">
                  <iframe
                    title={`${location.name} map`}
                    src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1000!2d${location.coordinates.lng}!3d${location.coordinates.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s${location.placeId}!2s!5e0!3m2!1sen!2slk!4v1710338000000!5m2!1sen!2slk`}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-4 text-primary-600">
                    {location.name}
                  </h3>

                  {/* Address */}
                  <div className="flex items-start mb-6">
                    <svg
                      className="w-5 h-5 mr-3 text-gray-500 flex-shrink-0 mt-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                    </svg>
                    <span className="text-gray-600 leading-relaxed">
                      {location.address}
                    </span>
                  </div>

                  {/* Contact Buttons */}
                  <div className="flex gap-3">
                    <a
                      href={`tel:${location.phone}`}
                      className="flex-1 flex items-center justify-center px-4 py-2 bg-gray-50 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
                    >
                      <svg
                        className="w-4 h-4 mr-2 text-primary-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                      Call
                    </a>

                    <a
                      href={`https://wa.me/${location.whatsapp.replace(
                        /\+/g,
                        '',
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 flex items-center justify-center px-4 py-2 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors"
                    >
                      <svg
                        className="w-4 h-4 mr-2"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347" />
                      </svg>
                      WhatsApp
                    </a>
                  </div>

                  {/* Working Hours */}
                  {location.hoursDisplay && (
                    <div className="mt-6 pt-4 border-t border-gray-100">
                      <h4 className="font-medium mb-2 text-gray-900 flex items-center">
                        <svg
                          className="w-4 h-4 mr-2 text-primary-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        Working Hours
                      </h4>
                      <p className="text-sm text-gray-600">
                        {location.hoursDisplay}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Social Media Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Connect With Us
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Facebook */}
            <div className="space-y-6">
              <h3 className="text-xl font-bold text-center text-blue-600">
                Facebook
              </h3>
              <div className="space-y-4">
                {socialMedia.facebook.map((profile) => (
                  <a
                    key={profile.url}
                    href={profile.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center p-3 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
                  >
                    <svg
                      className="w-6 h-6 text-blue-600 mr-3"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                    {profile.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Instagram */}
            <div className="space-y-6">
              <h3 className="text-xl font-bold text-center text-pink-600">
                Instagram
              </h3>
              <div className="space-y-4">
                {socialMedia.instagram.map((profile) => (
                  <a
                    key={profile.url}
                    href={profile.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center p-3 bg-pink-50 rounded-lg hover:bg-pink-100 transition-colors"
                  >
                    <svg
                      className="w-6 h-6 text-pink-600 mr-3"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                    {profile.name}
                  </a>
                ))}
              </div>
            </div>

            {/* YouTube */}
            <div className="space-y-6">
              <h3 className="text-xl font-bold text-center text-red-600">
                YouTube
              </h3>
              <div className="space-y-4">
                <a
                  href={socialMedia.youtube.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center p-3 bg-red-50 rounded-lg hover:bg-red-100 transition-colors"
                >
                  <svg
                    className="w-6 h-6 text-red-600 mr-3"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                  {socialMedia.youtube.name}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
